import { paginatedQuery } from 'lib-shared-api-utils';
import {
  CreateUserApiArg,
  CreateUserApiResponse,
  PatchUserRolesApiArg,
  PatchUserRolesApiResponse,
  ReadAgentsApiArg,
  ReadAgentsApiResponse,
  ReadUserApiArg,
  ReadUserApiResponse,
  ReadUserRolesApiArg,
  ReadUserRolesApiResponse,
  ReadUsersApiArg,
  ReadUsersApiResponse,
  UpdateUserApiArg,
  UpdateUserApiResponse,
  UpdateUserRolesApiArg,
  UpdateUserRolesApiResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

export const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createUser: builder.mutation<CreateUserApiResponse, CreateUserApiArg>({
      query: (data) => ({
        version: 1,
        path: 'users',
        method: 'POST',
        data,
      }),
    }),
    readUser: builder.query<ReadUserApiResponse, ReadUserApiArg>({
      query: ({ id }) => ({
        version: 1,
        path: `users/${id}`,
      }),
    }),
    updateUser: builder.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
      query: ({ id, patch: body }) => ({
        version: 1,
        path: `users/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    readUsers: builder.query<ReadUsersApiResponse, ReadUsersApiArg>({
      query: (arg) =>
        paginatedQuery(arg, (arg) => ({
          version: 1,
          path: 'users',
          params: {
            id: arg.userIds,
            user_type: arg.userType,
          },
        })),
    }),
    readAgents: builder.query<ReadAgentsApiResponse, ReadAgentsApiArg>({
      query: (arg) =>
        paginatedQuery(
          arg,
          ({
            excludeTeamId: filter_out_by_team,
            excludeQueueId: filter_out_by_queue,
          }) => ({
            version: 1,
            path: 'users/agents',
            params: {
              filter_out_by_team,
              filter_out_by_queue,
            },
          }),
        ),
    }),
    readUserRoles: builder.query<ReadUserRolesApiResponse, ReadUserRolesApiArg>(
      {
        query: ({ userId }) => ({
          version: 1,
          path: `users/${userId}/roles`,
        }),
      },
    ),
    updateUserRoles: builder.mutation<
      UpdateUserRolesApiResponse,
      UpdateUserRolesApiArg
    >({
      query: ({ userId, roleIds }) => ({
        version: 1,
        path: `users/${userId}/roles`,
        method: 'PUT',
        body: {
          role_ids: roleIds,
        },
      }),
    }),
    patchUserRoles: builder.mutation<
      PatchUserRolesApiResponse,
      PatchUserRolesApiArg
    >({
      query: ({ userId, roleAdditions, roleDeletions }) => ({
        version: 1,
        path: `users/${userId}/roles`,
        method: 'PATCH',
        body: {
          role_additions: roleAdditions,
          role_deletions: roleDeletions,
        },
      }),
    }),
  }),
});
